import type { UserModel } from '@/domain/models/user.js';
import type { TranslateFn } from '@/shared/utils/format-date.js';

export type UserConfirmAction = { type: 'block' | 'unblock' | 'reset'; user: UserModel };

export type UserConfirmDialogOptions = {
    title: string;
    message: string;
    confirmLabel: string;
    confirmColor: 'error' | 'primary';
};

export function resolveUserConfirmDialog(action: UserConfirmAction | null, translate: TranslateFn): UserConfirmDialogOptions {
    const type = action?.type ?? 'reset';
    switch (type) {
        case 'block':
            return {
                title: translate('users.blockUserTitle'),
                message: translate('users.blockUserDesc', { name: action?.user.name }),
                confirmLabel: translate('users.confirmBlockBtn'),
                confirmColor: 'error'
            };
        case 'unblock':
            return {
                title: translate('users.unblockUserTitle'),
                message: translate('users.unblockUserDesc', { name: action?.user.name }),
                confirmLabel: translate('users.confirmUnblockBtn'),
                confirmColor: 'primary'
            };
        default:
            return {
                title: translate('users.userResetPasswordTitle'),
                message: translate('users.resetPasswordDesc', { name: action?.user.name, email: action?.user.email }),
                confirmLabel: translate('users.confirmReset'),
                confirmColor: 'primary'
            };
    }
}
